import script from "./Vsl.vue?vue&type=script&setup=true&lang=js"
export * from "./Vsl.vue?vue&type=script&setup=true&lang=js"

import "./Vsl.vue?vue&type=style&index=0&id=7e2a35bf&scoped=true&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e2a35bf"]])

export default __exports__